import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: {},
  isLoaded: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUser: (state, action) => {
      state.userData = action.payload;
      state.isLoaded = true;
    },
    logout: (state) => {
      state.userData = {};
      state.isLoaded = false;
    },
    clearStore: (state) => {
      state.userData = {};
      state.isLoaded = false;
    },
  },
});

export const { getUser, logout, clearStore } = userSlice.actions;

export default userSlice.reducer;
